import React from 'react';
import {
  Button, ButtonColor, ButtonIconSize, ButtonVariant, ICON_EMAIL,
} from '@doveit/bricks';
import { FACEBOOK, TWITTER, LINKEDIN } from '../../themes/icons';
import getSocialShareLinks from '../../utils/social-share-links/socialShareLinks';

export interface SocialShareLinksProps {
  url: string,
  title: string,
}

const socialIcons = {
  facebook: FACEBOOK,
  twitter: TWITTER,
  linkedin: LINKEDIN,
  email: ICON_EMAIL,
};

const SocialShareLinks: React.FC<SocialShareLinksProps> = ({
  url,
  title,
}) => {
  const shareLinks = getSocialShareLinks(url, title);

  return (
    <>
      {Object.entries(shareLinks).map(([social, link]) => (
        <Button
          key={social}
          href={link}
          rel="nofollow noopener"
          target="_blank"
          title="Condividi"
          color={ButtonColor.PRIMARY}
          icon={socialIcons[social]}
          iconSize={ButtonIconSize.BIG}
          variant={ButtonVariant.LIGHT}
        />
      ))}
    </>
  );
};

export default SocialShareLinks;
